import store from '../store';

import Store from '../views/setting/Store.vue';
import Framework from '../views/setting/Framework.vue';
import Marketplace from '../views/setting/Marketplace.vue';
import StmpEmail from '../views/setting/StmpEmail.vue';
import AiSocial from '../views/setting/AiSocial.vue';
import Payments from '../views/setting/Payments.vue';
import ApiPayments from '../views/setting/ApiPayments.vue';
import Language from '../views/setting/Language.vue';
import Currency from '../views/setting/Currency.vue';
import Finance from '../views/setting/Finance.vue';
import Listing from '../views/setting/Listings';
import Stats from '../views/setting/Stats';
import Seo from '../views/setting/Seo';
import Couriers from '../views/setting/Couriers';
import Packaging from '../views/setting/Packaging';
const PackagingCreate = () => import('../views/setting/packaging/Create.vue');
const PackagingEdit = () => import('../views/setting/packaging/Edit.vue');
import Vat from '../views/setting/Vat.vue';
import Unit from '../views/setting/Unit.vue';
import Thumbnail from '../views/setting/Thumbnail.vue';
import Storage from '../views/setting/Storage.vue';
import { checkauth } from '../Helper';
import Products from '../views/setting/Products';
import AdditionalTabs from '../views/setting/AdditionalTabs';
import StatusOrder from '../views/setting/StatusOrder';
import Permissions from '../views/setting/Permissions';
import PermissionsByProfile from '../views/setting/PermissionsByProfile';
import Communication from '../views/setting/Communication.vue';
import Notifications from '../views/setting/Notifications.vue';

export default [
	{
		path: '/setting/store',
		name: 'store',
		component: Store,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/language',
		name: 'language',
		component: Language,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/framework',
		name: 'framework',
		component: Framework,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/finance',
		name: 'finance',
		component: Finance,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/stats',
		name: 'stats',
		component: Stats,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/seo',
		name: 'seo',
		component: Seo,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/listing',
		name: 'listing',
		component: Listing,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/marketplace',
		name: 'marketplace',
		component: Marketplace,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/payments',
		name: 'payments',
		component: Payments,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/listcouries',
		name: 'couriers',
		component: Couriers,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				//console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/api-payments',
		name: 'api-payments',
		component: ApiPayments,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/currencies',
		name: 'currencies',
		component: Currency,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/vat',
		name: 'vat',
		component: Vat,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/unit',
		name: 'unit',
		component: Unit,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/storage',
		name: 'setting-storage',
		component: Storage,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/thumbnail',
		name: 'thumbnail',
		component: Thumbnail,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/products',
		name: 'products',
		component: Products,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/packaging',
		name: 'packaging',
		component: Packaging,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	// inserimento e modifica packaging sono pagine: tornando indietro la lista riparte dal suo URL
	{
		path: '/setting/packaging/new',
		name: 'packaging-new',
		component: PackagingCreate,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	// :id e' l'_id del packaging (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/setting/packaging/:id([0-9a-fA-F]{24})',
		name: 'packaging-edit',
		component: PackagingEdit,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/additional-tab',
		name: 'additionalTab',
		component: AdditionalTabs,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/status-order',
		name: 'statusOrder',
		component: StatusOrder,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/permissions',
		name: 'Permissions',
		component: Permissions,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/permissions-by-profile',
		name: 'PermissionsByProfile',
		component: PermissionsByProfile,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/smtp-email',
		name: 'StmpEmail',
		component: StmpEmail,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/ai-social',
		name: 'AiSocial',
		component: AiSocial,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/communication',
		name: 'Communication',
		component: Communication,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/setting/notifications',
		name: 'Notifications',
		component: Notifications,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
